



























import Vue from 'vue'
import helpers from '../../helpers'
import './VuMeter.scss'
import { isMobile } from 'mobile-device-detect'
import sleep from '@/testing/sleep'

export default Vue.extend({
  name: 'VuMeter',
  props: {
    stream: {
      // now 'fixed' by adding it to jest.config.js globals
      type: MediaStream, // works for application but not tests
      // type: Object as () => MediaStream, // works for tests but not application
    },
    volume: {
      type: Number,
      default: 100
    },
    direction: {
      type: String,
      default: 'vertical'
    },
    channel: {
      type: Number,
      default: 0
    },
    id: {
      type: String
    }
  },
  data: () => ({
    refId: '',
    context: null as AudioContext | null,
    maxv: 0.0,
    mic: null as MediaStreamAudioSourceNode | null,
    meter: null as null | HTMLCanvasElement,
    script: null as ScriptProcessorNode | null,
    databuffer: [] as number[],
    isMobile: isMobile
  }),
  watch: {
    stream () {
      this.connectToSource()
    }
  },
  created () {
    this.refId = helpers.makeId()
  },
  mounted: function () {
    if (this.isMobile) return // FIXME: VuMeter is disabled on mobile due to too high CPU load of current implementation.
    this.maxv = 0
    const meter = this.$refs[this.refId] as HTMLCanvasElement | undefined
    if (meter) {
      this.meter = meter
    }
    this.context = new AudioContext()
    this.script = this.context.createScriptProcessor(2048, 2, 1)
    this.connectToSource()
    this.requestRedraw()
  },
  beforeDestroy () {
    this.stop()
    this.meter = null
    if (this.context) {
      this.context.close()
    }
  },
  methods: {
    onaudioprocess (event): void {
      this.databuffer = event.inputBuffer.getChannelData(this.channel)
    },
    calculateDecibelVolume (): number {
      const length = this.databuffer.length
      for (let i = 0; i < length; i += 10) {
        const v = this.databuffer[i]
        if (v > this.maxv) {
          this.maxv = v
        }
      }
      this.maxv = this.formatNum(this.maxv)
      const tempDecibleVal = this.formatNum(20 * this.log10(this.maxv))
      const volumeScaled = this.scale(this.volume, 0, 100, -48, 0)
      return tempDecibleVal + volumeScaled
    },
    drawVolumeRect (): void {
      if (!this.meter) {
        this.requestRedraw()
        return
      }
      const ctx = this.meter.getContext('2d')
      if (ctx === null) {
        this.requestRedraw()
        return
      }
      const decibleVal = this.calculateDecibelVolume()
      const tempVal = this.scale(decibleVal, -45, 0, 0, 100)
      this.maxv -= 0.05
      if (this.maxv < 0) {
        this.maxv = 0
      }

      ctx.clearRect(0, 0, this.meter.width, this.meter.height)
      if (this.direction === 'horizontal') {
        const grd = ctx.createLinearGradient(0, 0, 100, 5)
        grd.addColorStop(0, '#8ded2d')
        grd.addColorStop(0.85, '#8ded2d')
        grd.addColorStop(0.90, '#ed8000')
        grd.addColorStop(1, 'red')
        // val = 100 is the end
        ctx.fillRect(0, 0, tempVal, 5)
        ctx.fillStyle = grd
      } else if (this.direction === 'vertical') {
        const grd = ctx.createLinearGradient(0, 0, 10, 100)
        grd.addColorStop(1, '#8ded2d')
        grd.addColorStop(0.15, '#8ded2d')
        grd.addColorStop(0.10, '#ed8000')
        grd.addColorStop(0, 'red')
        // -100 is the top
        ctx.fillRect(0, 100, 10, (tempVal * -1))

        ctx.fillStyle = grd
      }
      this.requestRedraw()
    },
    async requestRedraw (): Promise<void> {
      await sleep(100)
      if (this.meter) {
        window.requestAnimationFrame(this.drawVolumeRect)
      }
    },
    connectToSource (): void {
      try {
        if (this.stream !== null && this.stream !== undefined && this.context) {
          if (this.stream.active === true) {
            if (this.stream.getAudioTracks().length > 0) {
              this.mic = this.context.createMediaStreamSource(this.stream)
              if (this.mic && this.script) {
                this.mic.connect(this.script)
                this.script.connect(this.context.destination)
                this.script.onaudioprocess = this.onaudioprocess
              }
              this.connectionFail(false)
            }
          }
        }
      } catch (e) {
        console.error(e)
        this.connectionFail(e)
      }
    },
    connectionFail (e: Error | boolean) {
      if (e) {
        console.error(e)
      }
    },
    stop () {
      if (this.mic !== null) {
        this.mic.disconnect()
      }
      if (this.script !== null) {
        this.script.disconnect()
        this.script.onaudioprocess = null
      }
    },
    formatNum (num) {
      return parseFloat((Math.round(num * 100) / 100).toFixed(2))
    },
    log10 (x) {
      return Math.log(x)/Math.LN10
    },
    scale (num, in_min, in_max, out_min, out_max) {
      return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min
    }
  }
})
